// Library Methods
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IshiharaResult from "src/components/containers/shared/ReportSections/ReportGraph/ColorVisionGraph/IshiharaGraph/IshiharaResult/IshiharaResult";

// Types
import {
  ExamSectionReportType,
  IshiharaStateResponseType,
} from "src/services/exams/types";

type IshiharaType = {
  examData: ExamSectionReportType;
  isLiveUpdate?: boolean;
};

const Ishihara = ({ examData, isLiveUpdate = false }: IshiharaType) => {
  const { t } = useTranslation();

  const currentQuestion = useMemo(
    () => examData?.state?.currentQuestion,
    [examData?.state?.currentQuestion]
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      {currentQuestion && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            borderRadius: "4px",
            border: "1px solid #000",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              background: "#000",
              color: "#FFF",
              padding: "8px",
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            {t("Current Plate")}
          </Typography>

          <Box sx={{ padding: "8px" }}>
            <IshiharaResult
              colorVisionResult={currentQuestion}
              resultIndex={-1}
              isLiveUpdate={isLiveUpdate}
            />
          </Box>
        </Box>
      )}

      {examData?.state?.responses && examData?.state?.responses?.length > 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            borderRadius: "4px",
            border: "1px solid #000",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              background: "#000",
              color: "#FFF",
              padding: "8px",
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            {t("Patient Responses")}
          </Typography>

          <Grid container sx={{ padding: "8px" }} rowGap="16px">
            {examData?.state?.responses?.map((response, resultIndex) => (
              <Grid item xs={12} sm={6} key={`ishihara-result-${resultIndex}`}>
                <IshiharaResult
                  colorVisionResult={response as IshiharaStateResponseType}
                  resultIndex={resultIndex}
                  isLiveUpdate={isLiveUpdate}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default Ishihara;
